// Ant Design theme passed to <ConfigProvider theme={...}>.
// Single source of truth for primary palette, button radius, card shadow.
// Why centralized: brand drift between portal and editor would be impossible
// to spot in a tab toggle if we let each render their own theme.

const antdTheme = {
    token: {
        colorPrimary: '#1B2A5C',
        colorLink: '#3A86FF',
        colorBgBase: '#FFFFFF',
        colorTextBase: '#1B2A5C',
        borderRadius: 6,
        fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", sans-serif',
    },
    components: {
        Button: {
            controlHeight: 36,
        },
        Card: {
            boxShadow: '0 1px 2px rgba(27,42,92,0.06), 0 8px 24px rgba(27,42,92,0.06)',
        },
    },
};

export default antdTheme;
